import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class SearchLocationService {
    private readonly ROUTE = 'https://nominatim.openstreetmap.org';

    constructor(private http: HttpClient) {}

    getLocationResults(location: string) {
        const httpParams = new HttpParams().set('q', location).set('format', 'json');

        return this.http.get(this.ROUTE, { params: httpParams });
    }
}
